import { iaRa } from 'lib/helpers/utility';

import {
  CONFIRMATION_MODAL,
  MEDICATION_STATUS
} from 'components/shared/Forms/Custom/ProviderMedications/lib/constants';

export const onHandleUpdateStatus = ({
  formik = {},
  data = {},
  setConfirmationModal = () => null,
  handleStatusLabel = MEDICATION_STATUS.ACTIVE
}) => {
  if (!formik) {
    return;
  }

  const targetId = data?.id || data?.tempId;

  formik.setFieldValue(
    'medications',
    iaRa(formik?.values?.medications).map((medication) => {
      const medicationId = medication?.id || medication?.tempId;
      if (medicationId === targetId) {
        medication.status = handleStatusLabel;
      }

      return medication;
    })
  );

  setConfirmationModal(CONFIRMATION_MODAL);
};
